export default __webpack_public_path__ + "static/media/Audio-Number-6.1ac6e06f.mp3";